import { apiFetch } from "./apiClient";

export const getMenuList = async (hashcode) => {
  return apiFetch(
    `/get-menus/${hashcode}?page=1&limit=10`,
    {
      method: "GET",
    }
  );
};
